module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com_container",
    style: ('margin-top:' + _vm.screenHight + 'px'),
    attrs: {
      "show": _vm.showComment
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("最新评论"), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v(_vm._s(_vm.newArr.length))])]), _vm._v(" "), _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.hideComment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._l((_vm.newComment), function(n) {
    return (_vm.newComment) ? _c('section', {
      staticClass: "newData"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('img', {
      attrs: {
        "src": n.imgurl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "author"
    }, [_vm._v(_vm._s(n.author))]), _vm._v(" "), _c('p', {
      staticClass: "editetime"
    }, [_vm._v(_vm._s(n.editetime))]), _vm._v(" "), _c('span', {
      staticClass: "sendReply"
    })]), _vm._v(" "), _c('p', {
      staticClass: "comment_content"
    }, [_vm._v(_vm._s(n.content))]), _vm._v(" "), _c('div', {
      staticClass: "reply"
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.comData), function(c) {
    return _c('section', {
      staticClass: "comData"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('img', {
      attrs: {
        "src": c.imgurl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "author"
    }, [_vm._v(_vm._s(c.author))]), _vm._v(" "), _c('p', {
      staticClass: "editetime"
    }, [_vm._v(_vm._s(c.editetime))]), _vm._v(" "), _c('span', {
      staticClass: "sendReply"
    })]), _vm._v(" "), _c('p', {
      staticClass: "comment_content"
    }, [_vm._v(_vm._s(c.content))]), _vm._v(" "), _c('div', {
      staticClass: "reply"
    })])
  })], 2), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.screenHight),
      expression: "!screenHight"
    }],
    staticClass: "sendComment"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "发表评论",
      "value": ""
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发表")])]), _vm._v(" "), _c('section', {
    staticClass: "alert"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAlert),
      expression: "isShowAlert"
    }],
    staticClass: "js_dialog",
    attrs: {
      "id": "iosDialog2"
    }
  }, [_c('div', {
    staticClass: "weui-mask",
    on: {
      "click": _vm.hideAlert
    }
  }), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog"
  }, [_c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("发表评论前请先登录")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("登录")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b3c9558"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xcomment.vue
// module id = 250
// module chunks = 0